/** @format */

export interface LuceneExplanation {
  description: string;
  value: number;
  details?: LuceneExplanation[];
  match?: boolean;
}
